module.exports = "/legacy/2e914041783165c15a8d9347c994606c.svg";